<template>
  <v-app :style="appBackground">
    <the-header></the-header>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script setup>
import TheHeader from './components/TheHeader.vue'
import { useTheme } from 'vuetify'
import { computed } from 'vue'

const theme = useTheme()
const appBackground = computed(() => {
  return theme.global.current.value.dark
    ? { background: 'linear-gradient(135deg, #121212 0%, #2a0e4e 100%)' }
    : { background: 'linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)' }
})
</script>

<style>
#app {
  font-family: 'Pretendard', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

.v-application {
  background: transparent !important;
}

.v-btn:active {
  transform: scale(0.95);
  transition: transform 0.1s ease-in-out;
}
</style>